const venueDetailsES = {
  'acc.venue_info': 'Información del lugar',
  'acc.tax_settings': 'Configuración de impuestos',
  'payment_settings.payment_settings': '[ES] Payment Settings',
  'payment_settings.non_integrated_payments': '[ES] Non-Integrated Payments',
  'payment_settings.agreements': '[ES] Legal Terms and Conditions',
  'payment_settings.agreements.acknowledge': '[ES] I acknowledge',
  'payment_settings.save_success': '[ES] Changes successfully saved!',
  'payment_settings.save_failure': '[ES] Unable to save. Please try again.',
  'payment_settings.additional_message': '[ES] Payment Terminal Settings',
  'payment_settings.additional_message.cta.moneris': '[ES] Visit the Moneris Go Portal',
  'payment_settings.additional_message.banner.default':
    '[ES] Need to update payment terminal settings?',
  'payment_settings.additional_message.banner.moneris.body_1':
    '[ES] Receipt printing, tip values, and other terminal settings can be configured in the Moneris Go Portal.',
  'payment_settings.auto_close_table': '[ES] Auto-Close Table After Payment',
  'payment_settings.auto_close_table.description':
    '[ES] Applies only to payments made through Moneris’ Pay-at-Table application.',
  'payment_settings.tips': '[ES] Tips',
  'payment_settings.tip': '[ES] Tip Prompt',
  'payment_settings.tip.description':
    '[ES] Specify whether the tip prompt will appear on the terminal or receipt.',
  'payment_settings.tip.mode.note':
    '[ES] Note: Only Tip on Terminal is currently available. Tip on Receipt is coming soon.',
  'payment_settings.tip.mode.options.terminal': '[ES] Tip on Terminal',
  'payment_settings.tip.mode.options.terminal.description':
    '[ES] The tip prompt appears on the PAX screen during payment. Your batch closes automatically at the time you set.',
  'payment_settings.tip.mode.options.terminal.description.chase_pax':
    '[ES] The tip prompt appears on the PAX screen during payment.',
  'payment_settings.tip.mode.options.receipt': '[ES] Tip on Receipt',
  'payment_settings.tip.mode.options.receipt.description':
    '[ES] Guests add their tip to the printed receipt. At end of service time, enter the tips and close the batch on the POS.',
  'payment_settings.tip.mode.options.receipt.description.chase_pax':
    '[ES] Guests add their tip to the printed receipt. At the end of service time, enter the tips on the POS.',
  'payment_settings.tip.calculation': '[ES] Tip Calculation',
  'payment_settings.tip.calculation.description':
    '[ES] Select whether the tip is calculated post-tax, pre-tax, pre-discount.',
  'payment_settings.tip.calculation.options.post_tax': '[ES] Post-Tax',
  'payment_settings.tip.calculation.options.pre_tax': '[ES] Pre-Tax',
  'payment_settings.tip.calculation.options.pre_discount': '[ES] Pre-Discount',
  'payment_settings.tip.recommendation': '[ES] Suggested Tip Amounts (%)',
  'payment_settings.tip.recommendation.description':
    '[ES] Specify the suggested tip amounts that will display on the terminal or receipt.',
  'payment_settings.tip.exceptions': '[ES] Tip Exceptions',
  'payment_settings.tip.exceptions.description':
    '[ES] Override tip settings for specific terminals. All others use the settings above.',
  'payment_settings.tip.exceptions.add': '[ES] Add Exception',
  'payment_settings.tip.exceptions.none': '[ES] None',
  'payment_settings.tip.exceptions.terminal': '[ES] Terminal',
  'payment_settings.tip.exceptions.modal.add_title': '[ES] Add Tip Exception',
  'payment_settings.tip.exceptions.modal.edit_title': '[ES] Edit Tip Exception',
  'payment_settings.tip.exceptions.delete.confirm':
    '[ES] Are you sure you want to delete this tip exception?',
  'payment_settings.offline_payments': '[ES] Offline Payments',
  'payment_settings.offline_payments.description':
    '[ES] Keep taking card payments when the terminal loses its internet connection. Stored payments upload automatically once the connection returns.',
  'payment_settings.offline_payments.limits.title': '[ES] Offline limits',
  'payment_settings.offline_payments.limits.description':
    '[ES] Set the maximum you are willing to accept offline. Offline payments are not authorized in real time and may be declined when they upload.',
  'payment_settings.offline_payments.max_per_transaction_limit': '[ES] Per-transaction limit',
  'payment_settings.offline_payments.max_per_transaction_limit.description':
    '[ES] Max transaction size when offline, per terminal.',
  'payment_settings.offline_payments.max_per_card_limit': '[ES] Per-card limit',
  'payment_settings.offline_payments.max_per_card_limit.description':
    '[ES] Total allowed on one card while offline.',
  'payment_settings.offline_payments.max_total_limit': '[ES] Total offline limit',
  'payment_settings.offline_payments.max_total_limit.description':
    '[ES] Combined total across all offline payments before new ones are blocked.',
  'payment_settings.offline_payments.max_total_limit.tripos': '[ES] Total limit',
  'payment_settings.offline_payments.max_total_limit.description.tripos':
    '[ES] Sum of all offline transaction amounts, per terminal.',
  'payment_settings.offline_payments.banner.bar_tabs.header':
    "[ES] Bar tabs aren't supported offline",
  'payment_settings.offline_payments.banner.bar_tabs.body':
    "[ES] Pre-authorized bar tabs need a live connection. They can't be used while the terminal is offline.",
  'payment_settings.offline_payments.banner.venue_managed.header': '[ES] Managed by the venue',
  'payment_settings.offline_payments.banner.venue_managed.body':
    '[ES] Offline payments can only be edited by the venue. Because of the risk involved, this setting is not available to TouchBistro staff.',
  'payment_settings.offline_payments.banner.slower.pax.header': '[ES] Slower while offline',
  'payment_settings.offline_payments.banner.slower.pax.body':
    '[ES] While the terminal is offline, each transaction takes about 1 to 3 minutes to process, so allow extra time at checkout.',
  'payment_settings.offline_payments.banner.slower.payrix.header':
    '[ES] First offline transaction is slower',
  'payment_settings.offline_payments.banner.slower.payrix.body':
    '[ES] The first transaction after going offline takes about a minute to process. The ones after that are quick.',
  'payment_settings.offline_payments.banner.tip_on_terminal.header':
    '[ES] Requires Tip on Terminal',
  'payment_settings.offline_payments.banner.tip_on_terminal.body':
    '[ES] Offline payments are only available when tips are taken on the terminal. Tip on receipt is not supported with offline payments.',
  'payment_settings.offline_payments.errors.required':
    '[ES] Enter a limit to accept offline payments.',
  'payment_settings.agreements.offline_payments.title': '[ES] Before you turn on offline payments',
  'payment_settings.agreements.offline_payments.intro':
    '[ES] Offline payments let you keep accepting cards when the terminal is offline. Please review how it works before enabling.',
  'payment_settings.agreements.offline_payments.risk_authorization.title':
    '[ES] Not authorized in real time.',
  'payment_settings.agreements.offline_payments.risk_authorization.body':
    '[ES] Offline payments are approved when they upload, so some may be declined after the fact. You are responsible for any that do not clear.',
  'payment_settings.agreements.offline_payments.risk_timing.title': '[ES] Slower to start.',
  'payment_settings.agreements.offline_payments.risk_timing.body':
    '[ES] The first transaction after going offline takes about a minute; the rest are quick.',
  'payment_settings.agreements.offline_payments.risk_timing_pax.title':
    '[ES] Slower while offline.',
  'payment_settings.agreements.offline_payments.risk_timing_pax.body':
    '[ES] While offline, each transaction takes about 1 to 3 minutes to process. Allow extra time.',
  'payment_settings.agreements.offline_payments.risk_tip_terminal.title':
    '[ES] Requires Tip on Terminal.',
  'payment_settings.agreements.offline_payments.risk_tip_terminal.body':
    '[ES] Offline payments are not available when tips are taken on the receipt.',
  'payment_settings.agreements.offline_payments.risk_bar_tabs.title':
    "[ES] Bar tabs aren't supported offline.",
  'payment_settings.agreements.offline_payments.risk_bar_tabs.body':
    "[ES] Pre-authorized bar tabs need a live connection and can't be used while the terminal is offline.",
  'payment_settings.agreements.offline_payments.risk_limits.title': '[ES] You set the limits.',
  'payment_settings.agreements.offline_payments.risk_limits.body':
    '[ES] Choose a per-transaction limit and a total offline limit to cap your risk.',
  'payment_settings.agreements.offline_payments.acknowledge':
    '[ES] I understand the risks of accepting payments offline.',
  'payment_settings.agreements.offline_payments.confirm': '[ES] Turn on offline payments',
  'payment_settings.pre_authorized_payments': '[ES] Pre-Authorized Payments',
  'payment_settings.pre_authorized_payments.description':
    '[ES] Specify the initial amount to be held on the guest’s card.',
  'payment_settings.pre_authorized_payments.order_types': '[ES] Order Types',
  'payment_settings.pre_authorized_payments.order_types.description':
    '[ES] Select which order types you would like to allow pre-authorizations for.',
  'payment_settings.pre_authorized_payments.order_types.options.bar_tabs': '[ES] Bar Tabs',
  'payment_settings.pre_authorized_payments.order_types.options.tables': '[ES] Tables',
  'payment_settings.pre_authorized_payments.amount': '[ES] Authorized Amount',
  'payment_settings.pre_authorized_payments.amount.description':
    '[ES] Specify the initial amount to be held on the guest’s card.',
  'payment_settings.pre_authorized_payments.is_credit_card_mandatory':
    '[ES] Make Credit Card Mandatory',
  'payment_settings.pre_authorized_payments.is_credit_card_mandatory.description':
    '[ES] A credit card must be pre-authorized in order to proceed with the order.',
  'payment_settings.batch_close': '[ES] Batch Close',
  'payment_settings.batch_close.description':
    'Establezca la hora a la que sus terminales PAX cerrarán automáticamente su lote cada día para la liquidación.',
  'payment_settings.batch_close.note.header': '[ES] Important:',
  'payment_settings.batch_close.note.power_on':
    '[ES] <1>Your terminal must be powered <2>on</2> and open to the payment app at the scheduled batch time.</1>',
  'payment_settings.batch_close.note.paper_roll':
    'Asegúrese de que haya un rollo de papel cargado para que el informe de lote pueda imprimirse correctamente.',
  'payment_settings.batch_close.time': '[ES] Time',
  'payment_settings.batch_close.guidance':
    '[ES] Tip: Choose a batch time outside of your service hours for easier report reconciliation.',
  'payment_settings.errors.invalid_time': '[ES] Please enter a valid time (e.g. 2:15pm)',
  'payment_settings.errors.min_max': '[ES] Value must be between {{min}} and {{max}}',
  'payment_settings.surcharge': '[ES] Credit Card Surcharge',
  'payment_settings.surcharge.description':
    '[ES] Ability to charge a fee if a guest wishes to pay with their credit card. Available for in-venue transactions only.',
  'payment_settings.surcharge.amount': '[ES] Surcharge Fee (%)',
  'payment_settings.surcharge.amount.hint':
    '[ES] Enter the % as a number (e.g., for a 2% surcharge, enter 2 not 0.02).',
  'payment_settings.surcharge.amount.description':
    '[ES] Value cannot exceed the maximum allowed by applicable law or card brand rules. Consult your financial advisor.',
  'payment_settings.surcharge.amount.required': '[ES] Surcharge fee is required.',
  'payment_settings.surcharge.amount.decimal_error':
    '[ES] Enter a whole number or up to 2 decimal places (e.g., 2, 2.5, or 2.75).',
  'payment_settings.surcharge.require_guest_confirmation':
    '[ES] Require guest confirmation on terminal',
  'payment_settings.surcharge.banner.venue_managed.header': '[ES] Managed by the venue',
  'payment_settings.surcharge.banner.venue_managed.body':
    '[ES] Credit card surcharge can only be edited by the venue. Because of the risk involved, this setting is not available to TouchBistro staff.',
  'payment_settings.agreements.surcharge.chase_pax.body_1':
    '[ES] Credit card surcharge is restricted or prohibited in certain provinces in Canada and certain states in the U.S.A. and by certain card network rules. Please contact your legal professional or your local government for further guidance on whether you can implement a credit card surcharge.',
  'payment_settings.agreements.surcharge.chase_pax.body_2':
    '[ES] If you wish to apply a credit card surcharge, you will need to, among other things, notify the credit card networks and/or acquirers in advance as well as follow their surcharging rules.',
  'payment_settings.agreements.surcharge.chase_pax.body_3':
    '[ES] By setting up credit card surcharge on your TouchBistro product(s), you acknowledge and agree that it is your sole responsibility to meet all legal and card network requirements and all laws applicable to you. Non-compliance may result in regulatory consequences or fines.',
  'payment_settings.agreements.surcharge.payrix_pax.body_1':
    '[ES] Credit card surcharge is restricted or prohibited in certain provinces in Canada and certain states in the U.S.A. and by certain card network rules. Please contact your legal professional or your local government for further guidance on whether you can implement a credit card surcharge.',
  'payment_settings.agreements.surcharge.payrix_pax.body_2':
    '[ES] If you wish to apply a credit card surcharge, you will need to, among other things, notify the credit card networks and/or acquirers in advance as well as follow their surcharging rules.',
  'payment_settings.agreements.surcharge.payrix_pax.body_3':
    '[ES] By setting up credit card surcharge on your TouchBistro product(s), you acknowledge and agree that it is your sole responsibility to meet all legal and card network requirements and all laws applicable to you. Non-compliance may result in regulatory consequences or fines.',
  'payment_settings.agreements.surcharge.tsys_pax.body_1':
    '[ES] Credit card surcharge is restricted or prohibited in certain provinces in Canada and certain states in the U.S.A. and by certain card network rules. Please contact your legal professional or your local government for further guidance on whether you can implement a credit card surcharge.',
  'payment_settings.agreements.surcharge.tsys_pax.body_2':
    '[ES] If you wish to apply a credit card surcharge, you will need to, among other things, notify the credit card networks and/or acquirers in advance as well as follow their surcharging rules.',
  'payment_settings.agreements.surcharge.tsys_pax.body_3':
    '[ES] By setting up credit card surcharge on your TouchBistro product(s), you acknowledge and agree that it is your sole responsibility to meet all legal and card network requirements and all laws applicable to you. Non-compliance may result in regulatory consequences or fines.',
  'pos.receipt_settings': 'Configuración de recibos',
  'pos.receipt_frequency': 'Frecuencia de recepción',
  'pos.receipt_frequency_info':
    'Para cada tipo de pago, por favor elija la opción si las copias del recibo del comercio y del cliente se imprimirán siempre, nunca se imprimirán o se imprimirán cuando se solicite (al hacer clic en el botón “Imprimir recibo”).',
  'pos.receipt_frequency_info_ios':
    'Por favor elija la opción si las copias del recibo del comercio y del cliente se imprimirán siempre, nunca se imprimirán o se imprimirán cuando se solicite (al hacer clic en el botón “Imprimir recibo”).',
  'pos.print_frequency_never': 'Nunca se imprimirán',
  'pos.print_frequency_always': 'Imprimirán siempre',
  'pos.print_frequency_prompt': 'Imprimirán cuando se solicite',
  'pos.payment_type': 'Tipo de pago',
  'pos.merchant_copy': 'Copia del comerciante',
  'pos.customer_copy': 'Copia del cliente',
  'pos.save_changes': 'Guardar cambios',
  'pos.discard_changes': 'Descartar cambios',
  'pos.save_success': 'La configuración del recibo se ha actualizado.',
  'pos.order_settings_save_success': '[ES] Receipt settings has been updated',
  'pos.receipt_layout': 'Diseño de recibo',
  'pos.payment_receipt_printing': 'Impresión de recibos de pago',
  'pos.payment_receipt_printing_info':
    'Elija dónde se imprimen las copias del comerciante y del cliente.',
  'pos.print_payment_receipts_from': 'Imprimir recibos de pago desde',
  'pos.payment_receipt_destination_terminal': 'Terminal de pago',
  'pos.payment_receipt_destination_terminal_info':
    'Se imprime desde la impresora integrada de la terminal de pago.',
  'pos.payment_receipt_destination_pos_printer': 'Impresora de recibos del POS',
  'pos.payment_receipt_destination_pos_printer_info':
    'Se imprime desde la impresora de recibos global, a menos que se haya configurado una impresora de recibos local en la aplicación.',
  'pos.payment_receipt_printing_banner_header': 'Terminales sin impresora',
  'pos.payment_receipt_printing_banner_body':
    'Algunas terminales no tienen impresora integrada. Esas terminales siempre imprimen desde la impresora de recibos global, o desde la impresora de recibos local si se ha configurado una en la aplicación, sin importar la opción seleccionada arriba.',
  'pos.receipt_layout_info':
    'Por favor seleccione los campos opcionales que aparecerán en los recibos impresos del comercio y del cliente',
  'pos.venue_address': 'Dirección del lugar',
  'pos.email_address': 'Dirección de correo electrónico',
  'pos.phone_number': 'Número de teléfono',
  'pos.order_type': 'Tipo de orden',
  'pos.server': 'Servidor',
  'pos.tax': 'Números de identificación fiscal',
  'pos.footer_notes': 'Notas al pie',
  'pos.cash': 'Dinero',
  'pos.non_integrated': 'No integrado',
  'pos.order_ticket_number': 'Número de ticket de pedido',
  'pos.integrated': 'Integrado',
  'pos.inactive_timeout_5': '[ES] 5 Minutes',
  'pos.inactive_timeout_10': '[ES] 10 Minutes',
  'pos.inactive_timeout_15': '[ES] 15 Minutes',
  'pos.inactive_timeout_20': '[ES] 20 Minutes',
  'pos.inactive_timeout_30': '[ES] 30 Minutes',
  'pos.inactive_timeout_45': '[ES] 45 Minutes',
  'pos.inactive_timeout_60': '[ES] 1 Hour',
  'pos.order-management': '[ES] Order Management',
  'pos.order_management_info':
    '[ES] Configure additional options around the movement of orders, from start to finish, on the POS (Point of Sale)',
  'pos.toggle_order_state': '[ES] Enable "Ready" Order State',
  'pos.toggle_order_state_info':
    '[ES] This setting is useful if your venue operates a pickup counter or you would like to track when orders are collected',
  'pos.preparation_time_info_error': '[ES] Preparation time must be between 1 and 120',
  'pos.preparation_time': '[ES] Preparation time (in minutes)',
  'pos.preparation_time_info': '[ES] value must be between 1 and 120',
  'pos.moving_orders': '[ES] Moving orders through the “In Progress” state',
  'pos.moving_orders_info':
    '[ES] Controls how orders move out of the “in progress” state manually (by the user) or automatically (by configured prep time)',
  'pos.configure_register': '[ES] Configure Register',
  'pos.configure_register_description':
    '[ES] Customize the Register screen to fit your venue’s workflow',
  'pos.cash_bar_toggle_label': '[ES] Include Quick Cash buttons on the Register Screen',
  'pos.cash_bar_toggle_description':
    '[ES] These buttons enable staff to take cash orders in 1-tap, and are helpful for venues that make many cash transactions.',
  'pos.moving_orders_manually': 'Manually',
  'pos.moving_orders_automatically': '[ES] Automatically (based on PreparationTime)',
  'pos.moving_orders_note':
    '[ES] Note: Unpaid orders cannot move to “Closed” unless they are “Cancelled”. If the “Ready” tab has been disabled, orders will remain in the “In Progress” tab beyond the preparation time limit, until paid in full or cancelled manually by the user.',
  'pos.order_settings_saved_failure': '[ES] There was an error saving order settings',
  'branding.branding': '[ES] Branding',
  'branding.icon_header': '[ES] Logo',
  'branding.icon_subtitle': '[ES] Upload your logo to provide a consistent diner experience.',
  'branding.banner_header': '[ES] Banner Image',
  'branding.banner_subtitle':
    '[ES] Upload a banner image to showcase your menu or dining experience.',
  'branding.color_theme_header': '[ES] Color Theme',
  'branding.color_theme_subtitle': `[ES] Select or input your brand's primary and secondary colors.`,
  'branding.color_theme_live_preview': '[ES] Live Preview',
  'branding.color_primary_color_label': '[ES] Primary Color',
  'branding.color_secondary_color_label': '[ES] Secondary Color',
  'branding.color_primary_button': '[ES] Primary Button',
  'branding.color_link_button': '[ES] Link and icon',
  'branding.color_secondary_button': '[ES] Secondary Button',
  'branding.color_tertiary_button': '[ES] Tertiary Button',
  'branding.color_button_fails_wcag_contrast':
    '[ES] This color may be difficult for your diners to see.',
  'branding.color_white_error_primary': '[ES] Primary color cannot be white (#FFFFFF).',
  'branding.color_white_error_secondary': '[ES] Secondary color cannot be white (#FFFFFF).',
  'branding.same_color_error_primary':
    '[ES] Primary color cannot use the same #HEX as the secondary color.',
  'branding.same_color_error_secondary':
    '[ES] Secondary color cannot use the same #HEX as the primary color.',
  'branding.settings_saved_success': '[ES] Branding settings saved successfully',
  'branding.settings_saved_failure': '[ES] There was an error saving branding settings',
  'settings.settings': 'Configuración',
  'hours_scheduling.hours_scheduling': 'Horas y programación',
  'hours_scheduling.configure_day_parts': 'Configuración partes del día',
  'hours_scheduling.configure_day_parts_description':
    'Cree y organice sus partes del día para filtrar rápidamente entre horarios comerciales definidos y verlos en sus informes.',
  'hours_scheduling.no_day_parts_found': 'Actualmente no tienes ninguna parte del día.',
  'hours_scheduling.hours_of_operation': '[ES] Hours of Operation',
  'hours_scheduling.day_parts_delay_warning':
    '[ES] Changes to Day Parts may take a short time to be reflected in your reports.',
  'hours_scheduling.day_part_updated':
    '[ES] Day Parts have been updated. Changes may take a short time to be reflected in reports.',
  'hours_scheduling.hours_of_operation_desc':
    '[ES] Indicate when you are open for in-venue service.',
  'hours_scheduling.add_hours': '[ES] Add Hours',
  'hours_scheduling.start_time': '[ES] Start Time',
  'hours_scheduling.end_time': '[ES] End Time',
  'hours_scheduling.hours_of_operation.days_error_message':
    '[ES] Please select the day(s) this hours of operation is available.',
  'hours_scheduling.hours_of_operation.exceptions': '[ES] Exceptions',
  'hours_scheduling.hours_of_operation.exceptions.desc':
    '[ES] Days and times you are open for a special occasion, event, holiday, or other reason. Exceptions will override your normal Hours of Operation for the specified day(s).',
  'hours_scheduling.hours_of_operation.exceptions.add': '[ES] Add Exception',
  'hours_scheduling.hours_of_operation.closures': '[ES] Closures',
  'hours_scheduling.hours_of_operation.closures.desc':
    '[ES] Days and times you are closed for holidays, private events, renovations, or other reasons. Closures will override your regular Hours of Operation and any Exceptions you have created for the specified day(s).',
  'hours_scheduling.hours_of_operation.closures.add': '[ES] Add Closure',
  'hours_scheduling.hours_of_operation.date': '[ES] Date',
  'hours_scheduling.hours_of_operation.start_and_end_time': '[ES] Start & End Time',
  'hours_scheduling.hours_of_operation.exceptions.empty_message':
    '[ES] You currently have no Exceptions to be displayed.',
  'hours_scheduling.hours_of_operation.closures.empty_message':
    '[ES] You currently have no Closures to be displayed.',
  'hours_scheduling.hours_of_operation.exceptions.delete':
    '[ES] The exception was deleted successfully',
  'hours_scheduling.hours_of_operation.closures.delete':
    '[ES] The closure was deleted successfully',
  'hours_scheduling.hours_of_operation.exceptions.delete_title':
    '[ES] Are you sure you want to delete the exception on {{date}}?',
  'hours_scheduling.hours_of_operation.exceptions.delete_confirm_btn': '[ES] Delete Exception',
  'hours_scheduling.hours_of_operation.closures.delete_title':
    '[ES] Are you sure you want to delete the closure on {{date}}?',
  'hours_scheduling.hours_of_operation.closures.delete_confirm_btn': '[ES] Delete Closure',
  'hours_scheduling.hours_of_operation.exceptions_closures_subtitle':
    '[ES] This action is irreversible.',
  'hours_scheduling.add_exception': '[ES] Add Exception',
  'hours_scheduling.edit_exception': '[ES] Edit Exception',
  'hours_scheduling.add_closure': '[ES] Add Closure',
  'hours_scheduling.edit_closure': '[ES] Edit Closure',
  'hours_scheduling.when': '[ES] When',
  'hours_scheduling.all_day': '[ES] All Day',
  'hours_scheduling.exception_added_success': '[ES] Exception was added successfully',
  'hours_scheduling.exception_updated_success': '[ES] Exception was updated successfully',
  'hours_scheduling.closure_added_success': '[ES] Closure was added successfully',
  'hours_scheduling.closure_updated_success': '[ES] Closure was updated successfully',
  'hours_scheduling.hours_of_operation.conflict_service_time':
    '[ES] Heads up! The highlighted Hours of Operation below do not fit within your Service Time window of {{startTime}} to {{endTime}}.',
  'hours_scheduling.service_time.conflict_message':
    '[ES] Heads up! You have Hours of Operation that do not fit within your Service Time window. Your reports may be inaccurate.',
  'venue_details.venue_details': '[ES] Venue Details',
  'venue_details.basic_details': '[ES] Basic Details',
  'venue_details.contact': '[ES] Contact Details',
  'venue_details.online_presence': '[ES] Online Presence',
  'venue_details.venue_name': '[ES] Venue Name',
  'venue_details.venue_id': '[ES] Venue ID',
  'venue_details.business_number': '[ES] Business Number',
  'venue_details.currency': '[ES] Currency',
  'venue_details.currency_placeholder': '[ES] Select a currency',
  'venue_details.business_description': '[ES] Business Description',
  'venue_details.business_description_placeholder':
    "[ES] Enter a description of what you're known for",
  'venue_details.specialty': '[ES] Specialty',
  'venue_details.specialty_placeholder': '[ES] Enter your Specialty',
  'venue_details.parking_info': '[ES] Parking Info',
  'venue_details.dress_code': '[ES] Dress Code',
  'venue_details.categories_and_cuisine_types': '[ES] Categories and Cuisine Types',
  'venue_details.optional_sublabel': '[ES] Optional',
  'venue_details.specialty_length_restrict':
    '[ES] Oops! Specialty has to be 30 characters or less.',
  'venue_details.items_selected': '[ES] {{count}} Selected',
  'venue_details.select_option': '[ES] Select Option',
  'venue_details.select-options': '[ES] Select Options',
  'venue_details.save_success': '[ES] Venue details saved successfully!',
  'venue_details.save_failed': '[ES] An error occurred while saving venue details',
  'venue_details.warning.title': '[ES] Are you sure you want to change this information?',
  'venue_details.warning.body':
    "[ES] <2>Changing the <1>venue name, business number, or country</1>, could impact the venue's TouchBistro Payments account and existing integrations, if applicable. Please ensure these changes are also applied to the venue's TouchBistro Payments account and communicated to any applicable 3rd parties.</2>",
  'venue_details.address_line_1': '[ES] Address',
  'venue_details.address_line_2': '[ES] Apartment, Suite, etc.',
  'venue_details.city': '[ES] City',
  'venue_details.state_province': '[ES] State/Province',
  'venue_details.state_province.length_error': '[ES] Must be less than 26 characters',
  'venue_details.state_province.pattern_error':
    '[ES] Must look like ON, NY, or other 2 letter state/province code',
  'venue_details.zip_postal_code': '[ES] Zip/Postal Code',
  'venue_details.country': '[ES] Country',
  'venue_details.country.error':
    "[ES] Unfortunately, you cannot change the address's country. Please reach out to support if this is needed.",
  'venue_details.email': '[ES] Email',
  'venue_details.email.pattern_error':
    '[ES] Email must be a valid email address. E.g.: example@example.com',
  'venue_details.phone': '[ES] Phone',
  'venue_details.your_website': '[ES] Your Website',
  'venue_details.menu_links': '[ES] Menu Links',
  'venue_details.social_media': '[ES] Social Media',
  'venue_details.enter_a_valid_url': '[ES] Please enter a valid url.',
  'venue_details.enter_a_url': '[ES] Please enter a url.',
  'venue_details.enter_a_name': '[ES] Please enter a name.',
  'venue_details.menu_link_name_restrict':
    '[ES] Oops! Menu Link Name has to be 30 characters or less.',
  'venue_details.social_media_name_restrict':
    '[ES] Oops! Custom Social Media Label has to be 30 characters or less.',
  'venue_details.enter_name': '[ES] Enter Name',
  'venue_details.select_type': '[ES] Select Type',
  'venue_details.select_type_required': '[ES] Please select a type',
  'venue_details.custom_social_media': '[ES] Custom Social Media Type Here',
  'venue_details.add_menu_link': '[ES] Add Menu Link',
  'venue_details.add_social_media': '[ES] Add Social Media',
  'venue_details.parkingInfo.none': '[ES] No Parking',
  'venue_details.parkingInfo.street': '[ES] Street Parking',
  'venue_details.parkingInfo.lot': '[ES] Lot Parking',
  'venue_details.parkingInfo.pay': '[ES] Pay Parking',
  'venue_details.parkingInfo.valet': '[ES] Valet Parking',
  'venue_details.dressCode.casual': '[ES] Casual',
  'venue_details.dressCode.business_casual': '[ES] Business Casual',
  'venue_details.dressCode.jacket_preferred': '[ES] Jacket Preferred',
  'venue_details.dressCode.jacket_required': '[ES] Jacket Required',
  'venue_details.dressCode.jacket_and_tie_required': '[ES] Jacket & Tie Required',
  'venue_details.dressCode.formal_attire': '[ES] Formal Attire',
  'venue_details.cuisineTypes.african': '[ES] African',
  'venue_details.cuisineTypes.algerian': '[ES] Algerian',
  'venue_details.cuisineTypes.american': '[ES] American',
  'venue_details.cuisineTypes.argentina': '[ES] Argentina',
  'venue_details.cuisineTypes.asian': '[ES] Asian',
  'venue_details.cuisineTypes.barbecue': '[ES] Barbecue',
  'venue_details.cuisineTypes.belgian': '[ES] Belgian',
  'venue_details.cuisineTypes.bistro': '[ES] Bistro',
  'venue_details.cuisineTypes.brasserie': '[ES] Brasserie',
  'venue_details.cuisineTypes.brazilian': '[ES] Brazilian',
  'venue_details.cuisineTypes.breakfast': '[ES] Breakfast',
  'venue_details.cuisineTypes.bring_your_own_wine': '[ES] Bring your own wine',
  'venue_details.cuisineTypes.brunch': '[ES] Brunch',
  'venue_details.cuisineTypes.cajun_creole': '[ES] Cajun Creole',
  'venue_details.cuisineTypes.canadian': '[ES] Canadian',
  'venue_details.cuisineTypes.caribbean': '[ES] Caribbean',
  'venue_details.cuisineTypes.casual_fine_dining': '[ES] Casual fine dining',
  'venue_details.cuisineTypes.charcuterie': '[ES] Charcuterie',
  'venue_details.cuisineTypes.chinese': '[ES] Chinese',
  'venue_details.cuisineTypes.cocktail': '[ES] Cocktail',
  'venue_details.cuisineTypes.coffee': '[ES] Coffee',
  'venue_details.cuisineTypes.communal_seating': '[ES] Communal seating',
  'venue_details.cuisineTypes.contemporary_cuisine': '[ES] Contemporary cuisine',
  'venue_details.cuisineTypes.continental': '[ES] Continental',
  'venue_details.cuisineTypes.craft_beer': '[ES] Craft beer',
  'venue_details.cuisineTypes.craft_cider': '[ES] Craft cider',
  'venue_details.cuisineTypes.creperie': '[ES] Creperie',
  'venue_details.cuisineTypes.cuban': '[ES] Cuban',
  'venue_details.cuisineTypes.deli': '[ES] Deli',
  'venue_details.cuisineTypes.desserts_and_sweets': '[ES] Desserts and sweets',
  'venue_details.cuisineTypes.eastern_european': '[ES] Eastern European',
  'venue_details.cuisineTypes.ethiopian': '[ES] Ethiopian',
  'venue_details.cuisineTypes.family_friendly': '[ES] Family friendly',
  'venue_details.cuisineTypes.filipino': '[ES] Filipino',
  'venue_details.cuisineTypes.fine_dining': '[ES] Fine dining',
  'venue_details.cuisineTypes.fish': '[ES] Fish',
  'venue_details.cuisineTypes.fondue': '[ES] Fondue',
  'venue_details.cuisineTypes.french': '[ES] French',
  'venue_details.cuisineTypes.french_bistro': '[ES] French bistro',
  'venue_details.cuisineTypes.generic': '[ES] Generic',
  'venue_details.cuisineTypes.german': '[ES] German',
  'venue_details.cuisineTypes.gluten_free_cooking': '[ES] Gluten free cooking',
  'venue_details.cuisineTypes.greek': '[ES] Greek',
  'venue_details.cuisineTypes.grill': '[ES] Grill',
  'venue_details.cuisineTypes.halal': '[ES] Halal',
  'venue_details.cuisineTypes.hamburgers': '[ES] Hamburgers',
  'venue_details.cuisineTypes.hungarian': '[ES] Hungarian',
  'venue_details.cuisineTypes.indian': '[ES] Indian',
  'venue_details.cuisineTypes.indonesian': '[ES] Indonesian',
  'venue_details.cuisineTypes.international': '[ES] International',
  'venue_details.cuisineTypes.irish': '[ES] Irish',
  'venue_details.cuisineTypes.italian': '[ES] Italian',
  'venue_details.cuisineTypes.italian_bistro': '[ES] Italian bistro',
  'venue_details.cuisineTypes.jamaican': '[ES] Jamaican',
  'venue_details.cuisineTypes.japanese': '[ES] Japanese',
  'venue_details.cuisineTypes.jewish': '[ES] Jewish',
  'venue_details.cuisineTypes.korean': '[ES] Korean',
  'venue_details.cuisineTypes.kosher': '[ES] Kosher',
  'venue_details.cuisineTypes.large_groups': '[ES] Large groups',
  'venue_details.cuisineTypes.latin': '[ES] Latin',
  'venue_details.cuisineTypes.lebanese': '[ES] Lebanese',
  'venue_details.cuisineTypes.lunch': '[ES] Lunch',
  'venue_details.cuisineTypes.market': '[ES] Market',
  'venue_details.cuisineTypes.mediterranean': '[ES] Mediterranean',
  'venue_details.cuisineTypes.mexican': '[ES] Mexican',
  'venue_details.cuisineTypes.microbrewery': '[ES] Microbrewery',
  'venue_details.cuisineTypes.middle_eastern': '[ES] Middle Eastern',
  'venue_details.cuisineTypes.moroccan': '[ES] Moroccan',
  'venue_details.cuisineTypes.nepalese': '[ES] Nepalese',
  'venue_details.cuisineTypes.north_american': '[ES] North American',
  'venue_details.cuisineTypes.outdoor': '[ES] Outdoor',
  'venue_details.cuisineTypes.oyster_bar': '[ES] Oyster bar',
  'venue_details.cuisineTypes.peruvian': '[ES] Peruvian',
  'venue_details.cuisineTypes.pizzeria': '[ES] Pizzeria',
  'venue_details.cuisineTypes.polish': '[ES] Polish',
  'venue_details.cuisineTypes.portuguese': '[ES] Portuguese',
  'venue_details.cuisineTypes.pretzels': '[ES] Pretzels',
  'venue_details.cuisineTypes.pub': '[ES] Pub',
  'venue_details.cuisineTypes.quebec': '[ES] Quebec',
  'venue_details.cuisineTypes.regional': '[ES] Regional',
  'venue_details.cuisineTypes.rotisserie': '[ES] Rotisserie',
  'venue_details.cuisineTypes.russian': '[ES] Russian',
  'venue_details.cuisineTypes.sandwiches': '[ES] Sandwiches',
  'venue_details.cuisineTypes.sausages': '[ES] Sausages',
  'venue_details.cuisineTypes.seafood': '[ES] Seafood',
  'venue_details.cuisineTypes.smoked_meat': '[ES] Smoked meat',
  'venue_details.cuisineTypes.spanish': '[ES] Spanish',
  'venue_details.cuisineTypes.steak_house': '[ES] Steak house',
  'venue_details.cuisineTypes.sugar_shack': '[ES] Sugar shack',
  'venue_details.cuisineTypes.sushi': '[ES] Sushi',
  'venue_details.cuisineTypes.switzerland': '[ES] Switzerland',
  'venue_details.cuisineTypes.tapas': '[ES] Tapas',
  'venue_details.cuisineTypes.tartares': '[ES] Tartares',
  'venue_details.cuisineTypes.terroir': '[ES] Terroir',
  'venue_details.cuisineTypes.thai': '[ES] Thai',
  'venue_details.cuisineTypes.tunisian': '[ES] Tunisian',
  'venue_details.cuisineTypes.turkish': '[ES] Turkish',
  'venue_details.cuisineTypes.vegan': '[ES] Vegan',
  'venue_details.cuisineTypes.vegetarian': '[ES] Vegetarian',
  'venue_details.cuisineTypes.vietnamese': '[ES] Vietnamese',
  'venue_details.cuisineTypes.west_coast': '[ES] West Coast',
  'venue_details.cuisineTypes.wine_bar': '[ES] Wine bar',
  'salesforce.customer_portal': '[ES] Customer Portal',
  'salesforce.go_to_customer_portal': '[ES] Go to Customer Portal',
  service_charges: '[ES] Service Charges',
  'service_charges.create': '[ES] Create Service Charge',
  'service_charges.delivery': '[ES] Delivery',
  'service_charges.delivery.definition':
    '[ES] Additional settings to trigger when the service chrge is automatically applied to a delivery order',
  'service_charges.delivery.waive_charge_conditions':
    '[ES] Waive this fee if it’s more than or equal to this amount ($)',
  'service_charges.delivery.assign_to_boundary': '[ES] Assign to an existing Delivery Boundary',
  'service_charges.delivery.charge_in_use': '[ES] {{label}} (In Use by {{deliveryFee}})',
  'service_charges.delivery.boundaries': '[ES] Assign to an existing Delivery Boundary',
  'service_charges.delivery.boundary_rule':
    '[ES] must be configured before a service charge can be assigned to it.',
  'service_charges.details': '[ES] Service Charge Details',
  'service_charges.details.requires_manager_override': '[ES] Requires Manager Approval',
  'service_charges.details.requires_manager_override_description':
    "[ES] Restrict this service charge to require a manager's approval to be added or removed",
  'service_charges.details.definition':
    "[ES] Service charges are additional charges added to a customer's order to help cover the cost of the services provided by your business. Service charges should not be based on payment methods like credit cards fees.",
  'service_charges.details.definition.surcharge_cta':
    "[ES] If you'd like to add fees on credit card transactions please configure",
  'service_charges.details.definition.surcharge_link': '[ES] Surcharges',
  'service_charges.details.definition.no_surcharge':
    "[ES] If you'd like to add fees on credit card transactions, ask us about our PAX payment solutions that support surcharge functionality.",
  'service_charges.details.charge_amount': '[ES] Fee Amount',
  'service_charges.details.charge_type': '[ES] What is the fee type?',
  'service_charges.details.charge_type.PERCENTAGE': '[ES] Fixed Percentage',
  'service_charges.details.charge_type.DOLLAR': '[ES] Fixed Amount',
  'service_charges.details.charge_type.OPEN': '[ES] Open Amount',
  'service_charges.details.charge_when_to_apply':
    '[ES] When would you like to apply the service fee?',
  'service_charges.details.charge_when_to_apply.post_discount': '[ES] Post-Discount',
  'service_charges.details.charge_when_to_apply.pre_discount': '[ES] Pre-Discount',
  'service_charges.details.charge_who_should_receive': '[ES] Who should receive the service fee?',
  'service_charges.details.charge_who_should_receive.VENUE': '[ES] The Venue',
  'service_charges.details.charge_who_should_receive.VENUE.description':
    '[ES] The service charge given to the venue will be reported as sales',
  'service_charges.details.charge_who_should_receive.EMPLOYEE': '[ES] The Employee',
  'service_charges.details.charge_who_should_receive.EMPLOYEE.description':
    '[ES] The service charge given to the employee will be reported as a gratuity',
  'service_charges.details.label': '[ES] Service Charge Name',
  'service_charges.details.label_required': '[ES] Service Charge Name is required',
  'service_charges.details.label_duplicate_error':
    '[ES] Another service charge with the same name already exists.',
  'service_charges.details.amount_required': '[ES] Service Charge Amount is required',
  'service_charges.form_percentage_amount_validation':
    '[ES] The service charge percentage must be between 0 - 100.',
  'service_charges.form_dollar_amount_validation': '[ES] The service charge has limit of $1000',
  'service_charges.details.label_validation_length':
    '[ES] Service charge name must be within 1 - 60 characters',
  'service_charges.order_types': '[ES] Order Types',
  'service_charges.order_types.instruction':
    '[ES] Choose which order types this service charge will automatically apply to.',
  'service_charges.order_types.err_required':
    '[ES] Must select as least one order type to create a Service Charge',
  'service_charges.order_types.manual': '[ES] Manual',
  'service_charges.order_types.manual.description':
    '[ES] Manually add the service charge to an order (Cannot be applied with other order types)',
  'service_charges.order_types.527931bf-5e0e-40e5-b731-ebe40fc288e2': '[ES] Dine In',
  'service_charges.order_types.527931bf-5e0e-40e5-b731-ebe40fc288e2.description':
    '[ES] Automatically apply the service charge to every dine in order',
  'service_charges.order_types.527931bf-5e0e-40e5-b731-ebe40fc288e2.settings':
    '[ES] Additional settings to trigger when the service charge is applied to a dine-in order',
  'service_charges.order_types.527931bf-5e0e-40e5-b731-ebe40fc288e2.min_party_size':
    '[ES] Minimum party size',
  'service_charges.order_types.527931bf-5e0e-40e5-b731-ebe40fc288e2.min_party_size.required':
    '[ES] Minimum party size is required',
  'service_charges.order_types.db826f17-616e-4122-bcb3-17f2bdf9426e': '[ES] Bar Tab',
  'service_charges.order_types.db826f17-616e-4122-bcb3-17f2bdf9426e.description':
    '[ES] Automatically apply the service charge to every bar tab',
  'service_charges.order_types.69d81a01-1d1f-40bf-8b9e-495b9c7766ab': '[ES] Takeout',
  'service_charges.order_types.69d81a01-1d1f-40bf-8b9e-495b9c7766ab.description':
    '[ES] Automatically apply the service charge to every takeout order (TB Online Ordering & in-house. Excluding 3rd party apps)',
  'service_charges.order_types.d7804873-7c58-4389-b095-9d02de96ceca': '[ES] Delivery',
  'service_charges.order_types.d7804873-7c58-4389-b095-9d02de96ceca.description':
    '[ES] Automatically apply the service charge to every delivery order (TB Online ordering & in-house)',
  'service_charges.taxes': 'Impuestos',
  'service_charges.taxes.apply': '[ES] Apply Tax?',
  'service_charges.taxes.definition':
    '[ES] Choose whether or not taxes should be applied to this service charge',
  'service_charges.taxes.apply.yes': 'Si',
  'service_charges.taxes.apply.no': 'No',
  service_charge_name: '[ES] Service Charge',
  service_charge_type: '[ES] Type',
  service_charge_amount: '[ES] Amount',
  service_charge_fulfillment: '[ES] Fulfillment',
  service_charge_taxes: '[ES] Taxes',
  service_charge_status: '[ES] Status',
  'service_charge.empty.message': "[ES] You currently don't have any Service Charges",
  'service_charge.delete_modal.title': "[ES] Are you sure you want to delete \n'{{label}}'?",
  'service_charge.delete.modal.message':
    '[ES] Deleting this service charge will not affect your past reports',
  'service_charge.delete.button.message': '[ES] Delete Service Charge',
  'service_charges.taxes.select':
    '[ES] Select the taxes that will be applied to the service charge',
  'service_charges.oo.configure_link':
    '<2>[ES] View <1>Service Charges</1> to configure your delivery charges</2>',
  'service_charges.edit': '[ES] Edit Service Charge',
  'service_charges.updated': '[ES] {{label}} has been updated',
  'delete_service_charge.success': '[ES] {{label}} has been deleted from Service Charges',
  delete_service_charge: '[ES] Delete Service Charge',
  'service_charges.no_tax_configured':
    '[ES] There are no taxes set up with this restaurant. Please set up the taxes from the Venue Info section.',
}

export default venueDetailsES
